export function formatDateStr(dateString: string): string {
  if (!dateString) return "";

  const [datePart] = dateString.split("T");
  const [year, month, day] = datePart.split("-").map(Number);

  const date = new Date(year, month - 1, day);

  return new Intl.DateTimeFormat("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric"
  }).format(date);
}

export function formatDateStrShort(dateString: string): string {
  if (!dateString) return "";

  const [datePart] = dateString.split("T");
  const [year, month, day] = datePart.split("-").map(Number);

  const date = new Date(year, month - 1, day);

  return new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric"
  }).format(date);
}
  
  
export function daysSince(dateString: string): number {
  const [year, month, day] = dateString.split("-").map(Number);

  // Crear fecha EXACTA en local sin desfase UTC
  const fecha = new Date(year, month - 1, day);
  const hoy = new Date();

  fecha.setHours(0, 0, 0, 0);
  hoy.setHours(0, 0, 0, 0);

  const diffMs = hoy.getTime() - fecha.getTime();
  return Math.floor(diffMs / (1000 * 60 * 60 * 24));
}

export function formatDateShortIntl2(dateString:string) {
  const date = new Date(dateString);

  const formatted = new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(date);

  // Cambia "08 Oct 2025" (ya está en formato correcto)
  return formatted;
}


export function getOnlyDate(datetime: string): string {
  const date = new Date(datetime);
  if (isNaN(date.getTime())) return '';

  return date.toISOString().split('T')[0];
}

export const getFormattedCurrentDate = (): string => {
  const today = new Date()

  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long',
    day: '2-digit',
  }).format(today)
}

export const addDaysAndFormat = (daysToAdd: number): string => {
  const today = new Date()
  const futureDate = new Date(today)

  futureDate.setDate(futureDate.getDate() + daysToAdd)

  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric', // <- clave para evitar "03"
  }).format(futureDate)
}

export function getRemainingDays(startDate:string, maxDays = 30) {
  const MS_PER_DAY = 1000 * 60 * 60 * 24;

  // Normalize input date
  const start = new Date(startDate);

  // Current date/time
  const now = new Date();

  // Calculate deadline (start date + maxDays)
  const deadline = new Date(start);
  deadline.setDate(deadline.getDate() + maxDays);

  // Difference in milliseconds
  const diffMs = deadline - now;

  // Convert to days (round up to count partial days as full)
  const daysRemaining = Math.ceil(diffMs / MS_PER_DAY);

  return daysRemaining;
}